import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhQueryAutoWeb, VhImage, VhEventMediator } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';
import { FunctionService} from 'vhobjects-service/src/services';
@Component({
  selector: 'atw-frame-products-viewed-config',
  templateUrl: './frame-products-viewed-config.component.html',
  styleUrls: ['./frame-products-viewed-config.component.scss']
})
export class AtwFrameProductsViewedConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() position: any; // xác định position là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any;
  @Output() changeOptionConfig = new EventEmitter<any>();
  width = 0;
  height = 0;
  public isViewAll: boolean = false;
  public isCollapsed: boolean = false;
  public currentViewAll: any = {};
  // Xử lý chỉ mở được 1 menu 1 lần
  public openMenu: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
  };
  public urlBackgroundImage = ''; // Hình ảnh nền của frame (nếu có)
  public gapSpace = 0;
  public loadComplete = false;
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_phan_tu',
      index: 2,
    },
    {
      title: 'dieu_chinh_vien_icon_trai',
      index: 3,
    },
    {
      title: 'dieu_chinh_vien_icon_phai',
      index: 4,
    },
    {
      title: 'hieu_ung',
      index: 5,
    },
    {
      title: 'nang_cao',
      index: 6,
    },
    {
      title: 'nang_cao',
      index: 7,
    }
  ];
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'Mặc định',
      deg: '180deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top,',
      name: 'tu_duoi_len_tren',
      deg: '0deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'Từ trái sang phải',
      deg: '90deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'Từ phải sang trái',
      deg: '270deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom right,',
      name: 'tu_trai_tren_sang_phai_duoi',
      deg: '135deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom left,',
      name: 'tu_phai_tren_sang_trai_duoi',
      deg: '225deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top right,',
      name: 'tu_trai_duoi_sang_phai_tren',
      deg: '45deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top left,',
      name: 'tu_phai_duoi_sang_trai_tren',
      deg: '315deg',
    },
  ];
  classUpdates = {
    "frame-products__pagination": {
      "background-color": "rgb(255, 255, 255)",
      "align-items": "center",
      "height": "50px",
      "display": "flex",
      "width": "100%",
      "margin-top": "10px",
      "justify-content": "center"
    },
    "frame-products__pagination-list-button": {
      "background-color": "transparent",
      "font-family": "Arial",
      "font-size": "16px",
      "gap": "0px",
      "display": "flex",
      "color": "green"
    },
    "frame-products__pagination-list-button--controll": {
      "align-items": "center",
      "border-style": "solid",
      "border-color": "#dddddd",
      "justify-content": "center",
      "font-size": "16px",
      "padding": "8px 16px",
      "color": "inherit",
      "display": "flex",
      "cursor": "pointer",
      "background-color": "#fff",
      "border-width": "1px",
      "font-family": "inherit"
    },
    "frame-products__pagination-list-button--page-number": {
      "font-size": "16px",
      "padding": "8px 16px",
      "display": "flex",
      "align-items": "center",
      "border-width": "1px",
      "background-color": "#fff",
      "border-style": "solid",
      "border-radius": "0px",
      "color": "#000",
      "font-family": "inherit",
      "cursor": "pointer",
      "border-color": "#ddd",
      "justify-content": "center"
    },
    "frame-products__pagination-list-button--active": {
      "color": "#fff",
      "border-width": "1px",
      "font-family": "inherit",
      "cursor": "pointer",
      "justify-content": "center",
      "border-color": "#ddd",
      "background-color": "#008000",
      "padding": "8px 16px",
      "border-style": "solid",
      "align-items": "center",
      "display": "flex",
      "font-size": "16px"
    },
    "frame-products__left-arrow--icon": {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
    },
    "frame-products__right-arrow--icon": {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
    }
  };

  configUpdates = {
    "left_arrow_icon_shadow": {
      "property_box_shadow": {
        "spread": 1,
        "type": "outset",
        "v-offset": 1,
        "h-offset": 1,
        "color": "#ffffffff",
        "blur": 1
      },
      "is_box_shadow": false
    },
    "right_arrow_icon_shadow": {
      "property_box_shadow": {
        "spread": 1,
        "type": "outset",
        "v-offset": 1,
        "h-offset": 1,
        "color": "#ffffffff",
        "blur": 1
      },
      "is_box_shadow": false
    },
    "goToPage_pagination": {
      "border_color": "#ddd",
      "color": "green",
      "border_style": "solid",
      "content_goToPage": "Tới trang",
      "background_color": "#fff",
      "font_size": 16,
      "border_radius": 0,
      "display": false,
      "border_width": 1
    },
    "content_pagination": {
      "content_left": "Trước",
      "content_right": "Sau"
    },
    "slick_dots": {
      "height": "41px",
      "border_radius": 0,
      "width": "58px",
      "background_style": "rectangle"
    },
    "animation-selected": {
      "id": "000000"
    },
    "frame-products__pagination": {
      "hide_pagination": false
    },
    "type_display": "slide",
    "icon_pagination": {
      "icon": true,
      "color": "green",
      "font_size": 16,
      "arrow_left_icon": "bi bi-chevron-left",
      "display": false,
      "background_color": "#fff",
      "border_radius": 0,
      "border_color": "#ddd",
      "arrow_right_icon": "bi bi-chevron-right",
      "border_width": 1
    },
    "background-color": {
			"gradient_arr": [
				"rgb(0, 0, 255)",
				"rgb(255, 255, 0)"
			],
			"background": "#8c52ff",
			"gradient_check": false,
			"value_range": 1,
			"gradient_type": "linear-gradient",
			"value_parameter": 100,
			"gradient_direction": ""
		},
    "background-color-item": {
			"gradient_arr": [
				"rgb(0, 0, 255)",
				"rgb(255, 255, 0)"
			],
			"background": "#8c52ff",
			"gradient_check": false,
			"value_range": 1,
			"gradient_type": "linear-gradient",
			"value_parameter": 100,
			"gradient_direction": ""
		},
  }

  animation: any = {};
  effect_hover = [];
  customize = [];

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhImage: VhImage,
    private matdialog: MatDialog,
    public vhEventMediator: VhEventMediator,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
  ) { }

  ngOnInit(): void {
    for (const key in this.classUpdates) {
      if (!this.class.hasOwnProperty(key)) {
        this.class[key] = this.classUpdates[key];
      } else {
        for (const key2 in this.classUpdates[key]) {
          if (!this.class[key].hasOwnProperty(key2)) {
            this.class[key][key2] = this.classUpdates[key][key2];
          }
        }
      }
    }

    for (const key in this.configUpdates) {
      if (!this.config.hasOwnProperty(key)) {
        this.config[key] = this.configUpdates[key];
      } else {
        for (const key2 in this.configUpdates[key]) {
          if (!this.config[key].hasOwnProperty(key2)) {
            this.config[key][key2] = this.configUpdates[key][key2];
          }
        }
      }
    }

    if (isPlatformBrowser(this.platformId)) {
      if (this.class && this.config) {
        this.loadComplete = true;
        // Khoảng cách giữa cột và dòng
        this.gapSpace = parseInt(
          this.class['frame-products__products']['gap'],
          10
        );
      }
      // phần này get dữ liệu json
      forkJoin([
        this.http.get('assets/data/effects/frame-products.json')
      ]).subscribe(([effects]: any) => {
        this.effect_hover = effects;
      })
    }
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb(viewMoreIndex) {
    const configMap = {
      5: {
        configKey: 'background-color',
        classKey: 'frame-products'
      },
      6: {
        configKey: 'background-color-item',
        classKey: 'frame-products__products--item'
      }
    };
  
    const configData = configMap[viewMoreIndex];
    if (!configData) return;
  
    const { configKey, classKey } = configData;
    const bgConfig = this.config[configKey];
    const gradient = bgConfig.gradient_check
      ? `linear-gradient(${bgConfig.gradient_direction}${bgConfig.gradient_arr})`
      : 'none';
  
    this.class[classKey]['background-image'] = gradient;
    this.updateObject();
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value, viewMoreIndex) {
    if (!value.includes('#')) return;

    const gradient = this.config['background-color' + (viewMoreIndex == 5 ? '' : '-item')];
    gradient.gradient_arr.push(`rgba(${this.hexToRGB(value)}, ${gradient.value_range})`);
    this.updateBackgroundRgb(viewMoreIndex);
  }

  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index, viewMoreIndex) {
    const configBg = this.config['background-color' + (viewMoreIndex == 5 ? '' : '-item')];
    if (configBg[`gradient_arr`].length > 1) {
      configBg[`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb(viewMoreIndex)
    }
  }

  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event, viewMoreIndex) {
    if (!isPlatformBrowser(this.platformId)) return;

    const configBg = this.config['background-color' + (viewMoreIndex == 5 ? '' : '-item')];
    // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
    configBg.gradient_type = direction.type;
    configBg.gradient_direction = direction.direction;
    this.class['frame-products' + (viewMoreIndex == 5 ? '' : '__products--item')]['background-image'] = 
      configBg.gradient_type + '(' + configBg.gradient_direction + configBg.gradient_arr.join(',') + ')';
    this.updateObject();
  }

  openHandler(value: string): void {
    for (const key in this.openMenu) {
      if (key !== value) {
        this.openMenu[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /** Hàm thực hiện kiểm tra điều kiện 1 hướng của viền và active option đấy nếu đủ điều kiện
   *
   * @param value
   */
  checkActiveDirectionBorder(value: any) {
    if (['0px', '0'].includes(value)) return false;
    return true;
  }


  /** Hàm sẽ thực hiện disable các option khi lựa chọn tải ảnh nền cho frame
   *
   * @param valueItem
   * @returns
   */
  checkDisableUploadImage(valueItem: any) {
    if (this.class['frame-products'].is_upload_image === valueItem)
      return false;
    return true;
  }


  //Hàm update class
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {

      });
  }

  //Hàm update class
  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {

      });
  }
  //Hàm update position
  updatePosition() {
    this.vhQueryAutoWeb
      .updateBlock(this.objectChoosing._id, {
        [this.device + 'position']: this.position,
      })
      .then((bool: any) => {

      });
  }

  updateStaticdata() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        staticdata: this.objectChoosing.staticdata,
      })
      .then((bool: any) => {

      });
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
       // console.log('updateObject', bool);
        if(this.objectChoosing.is_child_banner || this.objectChoosing.is_child_tabs || this.objectChoosing.is_child_collapse) {
            // nếu là frame-products con của banner thì bắn sự kiện frame-banner set lại z-index frame-products con
            // và bắn ra sự kiện choose-selected-ruler để set lại objectChoosing vì frame-banner, collapse, tabs không có vhObjectSelected nên sẽ ko tự bắn sự kiện được
            this.vhEventMediator.notifyOnConfigChanged({
              status: 'config-changed', 
              code: this.objectChoosing.id_object, 
            });
          }
      })
  }

  /**
  *Hàm update class vào database, và gửi cập nhật width, height cho object-selected
  */
  updateClassAndWidthHeight() {
    this.width = document.getElementById(this.objectChoosing._id).clientWidth;
    this.height = document.getElementById(this.objectChoosing._id).clientHeight;
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {

      })
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['frame-products']['width'] = event.width + 'px';
    if (event.height) this.class['frame-products']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClassAndWidthHeight()
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.stylesField[4])
  }

  updateTypeDisplay(){
    this.updateConfig();
    this.functionService.updateDimension(this.objectChoosing)
  }

}
